import 'bootstrap'
import { detect } from 'detect-browser'

import '../main.scss'

import { backendDomain, frontendDomain, protocol } from '../constants.js'
import { addClickTooltips, getCookie, getCurl2Url, requestToCurl, setCommonHtml, transformDropdownContent } from '../common_js.js'
import { languages } from '../languages.js'

import hljs from 'highlight.js/lib/core'
import plaintext from 'highlight.js/lib/languages/plaintext'
import bash from 'highlight.js/lib/languages/bash'
import clojure from 'highlight.js/lib/languages/clojure'
import csharp from 'highlight.js/lib/languages/csharp'
import dart from 'highlight.js/lib/languages/dart'
import elixir from 'highlight.js/lib/languages/elixir'
import go from 'highlight.js/lib/languages/go'
import http from 'highlight.js/lib/languages/http'
import java from 'highlight.js/lib/languages/java'
import javascript from 'highlight.js/lib/languages/javascript'
import json from 'highlight.js/lib/languages/json'
import kotlin from 'highlight.js/lib/languages/kotlin'
import matlab from 'highlight.js/lib/languages/matlab'
import objectivec from 'highlight.js/lib/languages/objectivec'
import ocaml from 'highlight.js/lib/languages/ocaml'
import php from 'highlight.js/lib/languages/php'
import powershell from 'highlight.js/lib/languages/powershell'
import python from 'highlight.js/lib/languages/python'
import r from 'highlight.js/lib/languages/r'
import ruby from 'highlight.js/lib/languages/ruby'
import rust from 'highlight.js/lib/languages/rust'
import swift from 'highlight.js/lib/languages/swift'
import yaml from 'highlight.js/lib/languages/yaml'

import getExampleTemplate from '../examples/get.sh'
import postExampleTemplate from '../examples/post.sh'
import authExampleText from '../examples/auth.sh'
import jsonExampleText from '../examples/json.sh'
// import filesExampleText from './examples/files.sh'
// import formExampleText from './examples/form.sh'

hljs.registerLanguage('plaintext', plaintext)

hljs.registerLanguage('bash', bash)
hljs.registerLanguage('clojure', clojure)
hljs.registerLanguage('csharp', csharp)
hljs.registerLanguage('dart', dart)
hljs.registerLanguage('elixir', elixir)
hljs.registerLanguage('go', go)
hljs.registerLanguage('http', http)
hljs.registerLanguage('java', java)
hljs.registerLanguage('javascript', javascript)
hljs.registerLanguage('json', json)
hljs.registerLanguage('kotlin', kotlin)
hljs.registerLanguage('matlab', matlab)
hljs.registerLanguage('objectivec', objectivec)
hljs.registerLanguage('ocaml', ocaml)
hljs.registerLanguage('php', php)
hljs.registerLanguage('powershell', powershell)
hljs.registerLanguage('python', python)
hljs.registerLanguage('r', r)
hljs.registerLanguage('ruby', ruby)
hljs.registerLanguage('rust', rust)
hljs.registerLanguage('swift', swift)
hljs.registerLanguage('yaml', yaml)

// TODO: include a Windows screenshot for Chrome and Firefox.
//
// TODO: put the curl input in the URL?
// TODO: print a diff of the raw resulting requests?
//
// TODO: add check box for scanning the clipboard?

// TODO: translate the site. The top languages are
// chinese
// russian
// portuguese
// japanese
// korean
// french
// spanish
// https://techblog.willshouse.com/2012/01/03/most-common-user-agents/
let useragent = 'Mozilla/5.0 (Windows NT 10.0; Win64; x64) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/109.0.0.0 Safari/537.36'
// For fun and future-proofing, put the user's
// actual User Agent in the examples
if (window.navigator && window.navigator.userAgent && window.navigator.userAgent.trim() && !/[^a-z0-9-/().;, _]/i.test(window.navigator.userAgent)) {
  useragent = window.navigator.userAgent
}

const getExampleText = getExampleTemplate.replace('{{useragent}}', useragent)
const postExampleText = postExampleTemplate.replace('{{useragent}}', useragent)

const rangeExpiration = document.getElementById('expiration-range')
const processSpinnerEl = document.getElementById('process-spinner')
const curlExamples = document.getElementById('curl-examples')
const curlCodeEl = document.getElementById('curl-code')
const urlTag = document.getElementById('url-tag')
const dropDownMenuProxyButton = document.getElementById('dropdownMenuProxy')
const dropdownMenuLocationButton = document.getElementById('dropdownMenuLocation')
const proxyLocationLabel = document.getElementById('proxy-location-label')
const proxyLocationDropdown = document.getElementById('proxy-location-dropdown')
const priceDiv = document.getElementById('price-div')
const privacyRadioPrivate = document.getElementById('privacy-radio-private')
const privacyRadioPublic = document.getElementById('privacy-radio-public')
const billingLabel = document.getElementById('billing-label')
const billingRadio = document.getElementById('billing-radio')
const flexRadioOwnBalance = document.getElementById('flexRadioOwnBalance')
const flexRadioOthersBalance = document.getElementById('flexRadioOthersBalance')
const dropdownMenuExecutionButton = document.getElementById('dropdownMenuExecution')

const generatedCodeEl = document.getElementById('generated-code')
const generatedUrl = document.getElementById('curl2url-url')
// const warningsEl = document.getElementById('warnings')
// const warningsContainerEl = document.getElementById('warnings-container')
const language = 'json'

const changeHighlight = (language) => {
  if (languages[language] && languages[language].hljs) {
    language = languages[language].hljs
  }
  const newClass = 'language-' + language

  let seen = false
  const generatedCodeEl = document.getElementById('generated-code')
  for (const cls of generatedCodeEl.classList) {
    if (cls === newClass) {
      seen = true
    } else if (cls.includes('language-')) {
      generatedCodeEl.classList.remove(cls)
    }
  }
  if (!seen) {
    generatedCodeEl.classList.add(newClass)
  }

  // const navbar = document.getElementById('language-navbar')
  // if (language === 'plaintext') {
  //   navbar.classList.add('error')
  // } else {
  //   navbar.classList.remove('error')
  // }

  hljs.highlightElement(generatedCodeEl)
}

const showIssuePromo = () => {
  document.getElementById('issue-promo').style.display = 'inline-block'
}

const hideIssuePromo = () => {
  document.getElementById('issue-promo').style.display = 'none'
}

const showCopyToClipboard = () => {
  document.getElementById('copy-to-clipboard').style.display = 'inline-block'
}

const hideCopyToClipboard = () => {
  document.getElementById('copy-to-clipboard').style.display = 'none'
}

const showExample = function (code) {
  curlCodeEl.value = code.trim()
  curlCodeEl.dispatchEvent(new Event('input', { bubbles: true, composed: true }))
}

const getExample = document.getElementById('get-example')
getExample.addEventListener('click', function (e) {
  e.preventDefault() // Don't scroll to the top of the page
  showExample(getExampleText)
})

const postExample = document.getElementById('post-example')
postExample.addEventListener('click', function (e) {
  e.preventDefault()
  showExample(postExampleText)
})

const basicAuthExample = document.getElementById('basic-auth-example')
basicAuthExample.addEventListener('click', function (e) {
  e.preventDefault()
  showExample(authExampleText)
})

const jsonExample = document.getElementById('json-example')
jsonExample.addEventListener('click', function (e) {
  e.preventDefault()
  showExample(jsonExampleText)
})

// const filesExample = document.getElementById('files-example')
// filesExample.addEventListener('click', function (e) {
//   e.preventDefault()
//   showExample(filesExampleText)
// })

// const formExample = document.getElementById('form-example')
// formExample.addEventListener('click', function (e) {
//   e.preventDefault()
//   showExample(formExampleText)
// })

const copyToClipboardEl = document.getElementById('copy-to-clipboard')
copyToClipboardEl.addEventListener('click', (e) => {
  e.preventDefault()
  const generatedCodeEl = document.getElementById('curl2url-url')
  const selection = window.getSelection()
  const range = document.createRange()
  range.selectNodeContents(generatedCodeEl)
  selection.removeAllRanges()
  selection.addRange(range)
  navigator.clipboard.writeText(generatedCodeEl.textContent)
})

const browsers = ['chrome', 'safari', 'firefox']
let userBrowser = 'chrome'
let userOS = 'mac'
try {
  const detectedBrowser = detect()
  if (detectedBrowser && detectedBrowser.name && browsers.includes(detectedBrowser.name)) {
    userBrowser = detectedBrowser.name
    if (detectedBrowser.os && detectedBrowser.os.toLowerCase().includes('windows')) {
      userOS = 'windows'
    }
  }
} catch {}

const showInstructions = function (browser) {
  if (!browsers.includes(browser)) {
    browser = userBrowser
  }
  for (const b of browsers) {
    const el = document.getElementById(b)
    if (b === browser) {
      el.classList.remove('d-none')
    } else {
      el.classList.add('d-none')
    }
  }

  if (browser === 'safari') {
    const screenshot = document.getElementById('screenshot')
    const [width, height] = {
      chrome: [648, 354], firefox: [733, 251], safari: [658, 373]
    }[browser]
    const newInnerHTML = `
          <source srcset="/images/${browser}.webp, /images/${browser}@2x.webp 2x" type="image/webp">
          <img class="img-fluid mx-auto d-block" src="/images/${browser}.png" srcset="/images/${browser}@2x.png 2x" width="${width}" height="${height}"alt="screenshot of browser DevTools showing how to copy a network request as curl">
        `
    if (screenshot.innerHTML == null || screenshot.innerHTML !== newInnerHTML) {
      screenshot.innerHTML = newInnerHTML
      screenshot.className = ''
    }
  } else {
    const screenshot = document.getElementById('screenshot')
    screenshot.className = 'd-none'
  }
}

for (const b of browsers) {
  const basicAuthExamples = document.getElementsByClassName('to-' + b)
  for (const basicAuthExample of basicAuthExamples) {
    basicAuthExample.addEventListener('click', function (e) {
      e.preventDefault()
      const browser = [...e.target.classList].filter(c => c.startsWith('to-'))
      if (browser.length) {
        showInstructions(browser[0].replace(/^to-/, ''))
      } else {
        showInstructions()
      }
    })
  }
}

function escapeHtml (unsafe) {
  return unsafe
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#039;')
}

async function sendCurl (generatedCode) {
  const parsedJson = JSON.parse(generatedCode)
  const executionOption = transformDropdownContent(dropdownMenuExecutionButton.textContent)
  if (executionOption === 'RUN_REQUEST_ON_DEMAND') {
    parsedJson.execution = 'BUTTON_REQUIRED'
  } else {
    parsedJson.execution = 'ON_ACCESS'
  }
  const isPrivateChecked = privacyRadioPrivate.checked
  if (isPrivateChecked) {
    parsedJson.privacy = 'PRIVATE'
  } else {
    parsedJson.privacy = 'PUBLIC'
  }
  const isOwnBalanceChecked = flexRadioOwnBalance.checked
  if (isOwnBalanceChecked) {
    parsedJson.billing = 'OWN_BALANCE'
  } else {
    parsedJson.billing = 'OTHERS_BALANCE'
  }

  const proxyOption = transformDropdownContent(dropDownMenuProxyButton.textContent)
  if (proxyOption !== 'NONE') {
    parsedJson.proxyLocation = transformDropdownContent(dropdownMenuLocationButton.textContent)
  }
  parsedJson.expirationDays = rangeExpiration.value
  parsedJson.method = parsedJson.method.toUpperCase()
  parsedJson.connectTimeout = parsedJson.connect_timeout
  delete parsedJson.connect_timeout
  parsedJson.followRedirects = parsedJson.follow_redirects
  delete parsedJson.follow_redirects
  parsedJson.rawUrl = parsedJson.raw_url
  delete parsedJson.raw_url
  parsedJson.authType = parsedJson.auth_type
  delete parsedJson.auth_type
  const token = getCookie('token')
  if (token !== '') {
    if (urlTag.value !== '') {
      parsedJson.tag = encodeURIComponent(urlTag.value)
    }
  }
  const bearerToken = `Bearer ${token}`
  // const urlParams = new URLSearchParams(parsedJson.data)
  // console.log(urlParams.toString())
  if (parsedJson.headers !== undefined) {
    const contentType = parsedJson.headers['content-type']
    if (parsedJson.data === '') {
      // pass
    } else if (contentType === undefined) {
      parsedJson.data = JSON.stringify(parsedJson.data)
    } else if (contentType.includes('x-www-form-urlencoded')) {
      // const params = new URLSearchParams(jsonResponse.data)
      // parsedJson.data = parsedJson.data
      // It remains the same
    } else if (contentType.includes('json')) {
      parsedJson.data = JSON.stringify(parsedJson.data)
    }
  } else {
    if (parsedJson.data !== '') {
      parsedJson.data = JSON.stringify(parsedJson.data)
    }
  }

  // parsedJson.data = JSON.stringify(parsedJson.data)
  // parsedJson.data = urlParams.toString()
  const generatedBody = JSON.stringify(parsedJson)
  const options = {
    method: 'POST',
    headers: new Headers({
      Origin: `${protocol}://${backendDomain}/`,
      'Accept-Encoding': 'gzip, deflate',
      'Accept-Language': 'en-US,en;q=0.8',
      'User-Agent': 'Mozilla/5.0 (X11; Linux x86_64) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/114.0.0.0 Safari/537.36',
      'Content-Type': 'application/json',
      'Access-Control-Allow-Origin': '*',
      Accept: 'application/json',
      Referer: 'http://localhost:8280/',
      'X-Requested-With': 'XMLHttpRequest',
      Connection: 'keep-alive',
      authorization: bearerToken
    }),
    mode: 'cors'
  }
  options.body = generatedBody
  return await fetch(`${protocol}://${backendDomain}/curl2url`, options)
}

const getRange = (rangeElement) => {
  const resultExpiration = document.getElementById('expiration-result')
  const rangeInt = parseInt(rangeElement.value)
  if (rangeInt === 1) {
    resultExpiration.innerText = '1 day'
  } else if (rangeInt === 366) {
    resultExpiration.innerText = 'Never'
  } else {
    resultExpiration.innerText = rangeElement.value + ' days'
  }
}

rangeExpiration.addEventListener('input', function (e) {
  // e.preventDefault() // Don't scroll to the top of the page
  getRange(this)
})
rangeExpiration.addEventListener('change', function (e) {
  // e.preventDefault() // Don't scroll to the top of the page
  getRange(this)
})

async function sendDisplaySendCurlResponse (response, curl2urlLink) {
  processSpinnerEl.className = processSpinnerEl.className + ' d-none'
  curlExamples.className = curlExamples.className + ' d-none'
  let error = ''
  const jsonBody = await response.json()
  if (response.status === 200) {
    // const jsonBody = await response.json()
    if (jsonBody.success) {
      const curl2urlUrl = `${protocol}://${frontendDomain}/curl2url/` + jsonBody.message
      // generatedCode = `<a href='${curl2urlUrl}'> ${curl2urlUrl} </a>`

      curl2urlLink.href = escapeHtml(curl2urlUrl)
      curl2urlLink.textContent = escapeHtml(curl2urlUrl)
      // curl2urlLink.appendChild(curl2urlUrl)
    } else {
      curlCodeEl.setAttribute('disabled', false)
      process.className = process.className.replace('d-none', '')
    }
    // remove trailing newline
    // if (generatedBody.endsWith('\n')) {
    //   generatedCode = generatedBody.slice(0, -1)
    // }
    hideIssuePromo()
    showCopyToClipboard()
  } else if (response.status === 429) {
    error = jsonBody.message
    hideCopyToClipboard()
  } else if (response.status === 501) {
    // error = jsonBody.message
    hideCopyToClipboard()
  } else {
    error = jsonBody.message
    hideCopyToClipboard()
  }
  return error
}

const process = document.getElementById('process')

async function handleCurl2UrlExceptions (curlCode, e) {
  let error
  curlCodeEl.removeAttribute('disabled')
  process.className = process.className.replace('d-none', '')
  processSpinnerEl.className = processSpinnerEl.className + ' d-none'
  const origErrorMsg = e.toString()
  if (origErrorMsg) {
    if (origErrorMsg.startsWith('Error: ')) {
      error = origErrorMsg
    } else {
      error = 'Error parsing curl command: ' + origErrorMsg
    }
  } else if (!curlCode.trim().startsWith('curl')) {
    error = 'Error parsing curl command. Your input should start with the word "curl"'
  } else {
    error = 'Error parsing curl command.'
  }
  changeHighlight('plaintext')
  showIssuePromo()
  hideCopyToClipboard()
  return error
}

// async function handleGenerateCurl2UrlExceptions (curlCode, e) {
//   let error
//   curlCodeEl.removeAttribute('disabled')
//   process.className = process.className.replace('d-none', '')
//   processSpinnerEl.className = processSpinnerEl.className + ' d-none'
//   const origErrorMsg = e.toString()
//   if (origErrorMsg) {
//     if (origErrorMsg.startsWith('Error: ')) {
//       error = origErrorMsg
//     } else {
//       error = 'Error parsing curl command: ' + origErrorMsg
//     }
//   } else if (!curlCode.trim().startsWith('curl')) {
//     error = 'Error parsing curl command. Your input should start with the word "curl"'
//   } else {
//     error = 'Error parsing curl command.'
//   }
//   changeHighlight('plaintext')
//   showIssuePromo()
//   hideCopyToClipboard()
//   return error
// }

function displayCurl2UrlErrors (error, curl2urlLink) {
  if (!error) {
    if (generatedUrl.lastChild !== null) {
      generatedUrl.removeChild(generatedUrl.lastChild)
    }
    const curl2urlHeader = document.createElement('h3')
    curl2urlHeader.appendChild(curl2urlLink)
    generatedUrl.appendChild(curl2urlHeader)
    generatedCodeEl.textContent = ''
    changeHighlight(language)
  } else {
    generatedCodeEl.textContent = error
    generatedUrl.textContent = ''
    changeHighlight('plaintext')
  }
}

function disableElementsWhenCall () {
  rangeExpiration.setAttribute('disabled', true)
  urlTag.setAttribute('disabled', true)
  dropDownMenuProxyButton.setAttribute('disabled', true)
  dropdownMenuLocationButton.setAttribute('disabled', true)
  privacyRadioPublic.setAttribute('disabled', true)
  privacyRadioPrivate.setAttribute('disabled', true)
  flexRadioOwnBalance.setAttribute('disabled', true)
  flexRadioOthersBalance.setAttribute('disabled', true)
  dropdownMenuExecutionButton.setAttribute('disabled', true)
}

function enableElementsWhenFail () {
  rangeExpiration.removeAttribute('disabled')
  urlTag.removeAttribute('disabled')
  if (!flexRadioOthersBalance.checked) {
    dropDownMenuProxyButton.removeAttribute('disabled')
    dropdownMenuLocationButton.removeAttribute('disabled')
  }
  privacyRadioPublic.removeAttribute('disabled')
  privacyRadioPrivate.removeAttribute('disabled')
  flexRadioOwnBalance.removeAttribute('disabled')
  flexRadioOthersBalance.removeAttribute('disabled')
  dropdownMenuExecutionButton.removeAttribute('disabled')
}

process.addEventListener('click', async (e) => {
  e.preventDefault()
  // Display end
  let curlCode = curlCodeEl.value
  try {
    window.sessionStorage.setItem('prev-curl-command', curlCode)
  } catch {}
  let generatedCode
  let error
  let warnings = []

  // Convert the placeholder text as a demo
  if (!curlCode) {
    curlCode = 'curl example.com'
  }
  // Remove leading $
  if (curlCode.match(/^\s*\$\s+curl\s+/)) {
    curlCode = curlCode.replace(/^\s*\$\s*/, '')
  }
  // If command starts with a non-breaking space, replace all of them with a space
  if (curlCode.startsWith('curl\u00A0')) {
    curlCode = curlCode.replace(/\u00A0/g, ' ')
  }
  const curl2urlLink = document.createElement('a')
  // CONVERT CODE
  if (!curlCode.trim()) {
    error = ''
    hideIssuePromo()
    hideCopyToClipboard()
  } else {
    try {
      const converter = languages[language].converter;
      [generatedCode, warnings] = converter(curlCode, warnings)
      const url = new URL(JSON.parse(generatedCode).url)
    } catch (e) {
      error = await handleCurl2UrlExceptions(curlCode, e)
    }
  }
  displayCurl2UrlErrors(error, curl2urlLink)
  if (userOS === 'windows' && curlCode.split('^', 6).length > 5) {
    warnings.push(['copy-as-cmd', 'Did you click "Copy as cURL (cmd)" instead of "Copy as cURL (bash)"? Only bash commands are supported.'])
  }
  if (warnings && warnings.length) {
    const warningsText = warnings.map(w => w[1]).join('\n')
    displayCurl2UrlErrors(warningsText, curl2urlLink)
    // warningsContainerEl.style.display = 'inline-block'
  } else {
    displayCurl2UrlErrors(undefined, curl2urlLink)
    // generatedCodeEl.textContent = ''
    // warningsContainerEl.style.display = 'none'
    try {
      // Display Curl creation start
      processSpinnerEl.className = processSpinnerEl.className.replace('d-none', '')
      process.className = process.className + ' d-none'
      curlCodeEl.setAttribute('disabled', true)
      disableElementsWhenCall()
      const response = await sendCurl(generatedCode)
      error = await sendDisplaySendCurlResponse(response, curl2urlLink)
    } catch (e) {
      enableElementsWhenFail()
      error = await handleCurl2UrlExceptions(curlCode, e)
    }
    displayCurl2UrlErrors(error, curl2urlLink)
  }
})

function setSessionStorageQuery () {
  try {
    const prevCommand = window.sessionStorage.getItem('prev-curl-command')
    if (prevCommand && !curlCodeEl.value) {
      curlCodeEl.value = prevCommand
    }
  } catch {}
}

async function getRequest () {
  const queryString = window.location.search
  const urlParams = new URLSearchParams(queryString)
  const requestKey = 'request-id'
  if (urlParams.has(requestKey)) {
    const requestId = urlParams.get(requestKey)
    try {
      const responseResponse = await getCurl2Url(requestId)
      if (responseResponse.status === 200) {
        const jsonRequest = await responseResponse.json()
        const curl = requestToCurl(jsonRequest)
        curlCodeEl.value = curl
        window.sessionStorage.setItem('prev-curl-command', curl)
      } else if (responseResponse.status === 429) {
        const requestUrlAlert = document.getElementById('request-url-alert')
        requestUrlAlert.textContent = 'Requests throttled. You exceeded max requests'
        requestUrlAlert.style.display = 'block'
      } else {
        const requestUrlAlert = document.getElementById('request-url-alert')
        requestUrlAlert.style.display = 'block'
        curlCodeEl.value = ''
      }
    } catch (e) {
      const requestUrlAlert = document.getElementById('request-url-alert')
      requestUrlAlert.textContent = 'Request not available at the moment'
      requestUrlAlert.style.display = 'block'
    }
  } else {
    setSessionStorageQuery()
  }
}

const dropDownMenus = document.querySelectorAll('.dropdown-menu li a')

function hideLocationProxies () {
  proxyLocationLabel.style.display = 'none'
  proxyLocationDropdown.style.display = 'none'
  const pricePerGb = document.getElementById('price-per-gb')
  pricePerGb.textContent = '$ 19'
}

Array.from(dropDownMenus).map((element) => {
  element.addEventListener('click', function () {
    const textContent = element.textContent
    this.closest('.dropdown').querySelector('.dropdown-toggle').textContent = textContent
    if (textContent === 'Residential Proxy') {
      proxyLocationLabel.style.display = 'inline-block'
      proxyLocationDropdown.style.display = 'inline-block'
      const pricePerGb = document.getElementById('price-per-gb')
      pricePerGb.textContent = '$ 29'
    } else if (textContent === 'None') {
      hideLocationProxies()
    }
  })
  return element
})

const setPrice = () => {
  const token = getCookie('token')
  if (token !== '') {
    const pricePerGb = document.getElementById('price-per-gb')
    pricePerGb.textContent = '$ 19'
  }
  priceDiv.style.display = 'flex'
}

const disableRangeAnonymous = (rangeElement) => {
  const token = getCookie('token')
  if (token !== '') {
    // dropdownMenuExecutionButton.removeAttribute('disabled')
    rangeExpiration.removeAttribute('disabled')
    urlTag.removeAttribute('disabled')
    dropDownMenuProxyButton.removeAttribute('disabled')
    privacyRadioPublic.removeAttribute('disabled')
    privacyRadioPrivate.removeAttribute('disabled')
    privacyRadioPrivate.setAttribute('checked', true)
  }
}

urlTag.addEventListener('input', (event) => {
  urlTag.value = event.target.value.toLowerCase().replace(/[\W]+/g, '')
})

privacyRadioPrivate.addEventListener('click', (event) => {
  if (privacyRadioPrivate.checked) {
    billingLabel.style.display = 'none'
    billingRadio.style.display = 'none'
    dropDownMenuProxyButton.removeAttribute('disabled')
    dropdownMenuLocationButton.removeAttribute('disabled')
    flexRadioOwnBalance.checked = true
  }
})

privacyRadioPublic.addEventListener('click', (event) => {
  if (privacyRadioPublic.checked) {
    billingLabel.style.display = 'inline-block'
    billingRadio.style.display = 'inline-block'
  }
})

flexRadioOthersBalance.addEventListener('click', (event) => {
  if (flexRadioOthersBalance.checked) {
    dropDownMenuProxyButton.setAttribute('disabled', true)
    hideLocationProxies()
    dropDownMenuProxyButton.textContent = 'None'
  }
})

flexRadioOwnBalance.addEventListener('click', (event) => {
  if (flexRadioOwnBalance.checked) {
    dropDownMenuProxyButton.removeAttribute('disabled')
  }
})
setTimeout(async function () { await getRequest() }, 0)
setCommonHtml()
addClickTooltips()
rangeExpiration.value = 2
setPrice()
disableRangeAnonymous()
curlCodeEl.removeAttribute('disabled')
curlCodeEl.focus()
// convert()
hideCopyToClipboard()
showInstructions()
